<template>
  <div>
    <v-row>
      <v-col cols="12" md="4" class="pt-0">
        <div class="header text-left">Homepage Layout</div>
      </v-col>
      <v-col cols="12" md="8" class="action-buttons pt-0">
        <v-col cols="12" md="4">
          <v-row>
            <label for="lyt-rows" class="layout">Rows: </label>
            <select class="dd-layout" v-model="serviceRows">
              <option></option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select>
          </v-row>
        </v-col>
        <v-col cols="12" md="4">
          <v-row>
            <label for="lyt-rows" class="layout">Columns: </label>
            <select class="dd-layout" v-model="serviceColumns">
              <option></option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn class="create-btn" color="#00457C" @click="updateLayout"
            >Update Layout</v-btn
          >
        </v-col>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="7" class="pt-0">
        <div class="header text-left">Manage Homepage - Services</div>
      </v-col>
      <v-col cols="12" md="5" class="action-buttons pt-0">
        <v-btn class="filter-btn" color="#FDBB30">Filter</v-btn>
        <v-btn class="create-btn" color="#00457C" @click="createServices"
          >Create Homepage Services Item</v-btn
        >
      </v-col>
    </v-row>

    <TableComponent
      type="homepagePromotions"
      v-bind:dynamicHeaders="dynamicHeaders"
      v-bind:dynamicWidths="dynamicWidths"
      v-bind:dynamicRowsDetail="dynamicRowsDetailAll"
      v-on:view-item="viewPopup"
      v-on:edit-item="editPopup"
      v-on:delete-item="deletePopup"
    />

    <v-row style="margin-top: 30px">
      <v-col cols="12" md="7" class="pt-0">
        <div class="header text-left">Services - More</div>
      </v-col>
      <v-col cols="12" md="5" class="action-buttons pt-0">
        <v-btn class="filter-btn" color="#FDBB30">Filter</v-btn>
        <v-btn class="create-btn" color="#00457C" @click="createServices"
          >Create Services-More Item</v-btn
        >
      </v-col>
    </v-row>
    <TableComponent
      type="homepagePromotions"
      v-bind:dynamicHeaders="dynamicHeaders"
      v-bind:dynamicWidths="dynamicWidths"
      v-bind:dynamicRowsDetail="dynamicRowsDetailMore"
      v-on:view-item="viewPopup"
      v-on:edit-item="editPopup"
      v-on:delete-item="deletePopup"
    />
  </div>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import Axios from "axios";

export default {
  components: {
    TableComponent,
  },
  created() {
    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/services/getMain").then(
      (res) => {
        this.dynamicRowsDetailAll = this.processFetchedData(res.data);
      }
    );

    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/services/getMore").then(
      (res) => {
        this.dynamicRowsDetailMore = this.processFetchedData(res.data);
      }
    );

    Axios.get(
      process.env.VUE_APP_HOST_SERVER + "/api/services_layout/get"
    ).then((res) => {
      this.serviceColumns = res.data.columns;
      this.serviceRows = res.data.rows;
    });
  },
  data() {
    return {
      dynamicHeaders: [
        { text: "Title", value: "title" },
        { text: "Row", value: "row" },
        { text: "Column", value: "column" },
        { text: "isEnabled", value: "isEnabled" },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["40%", "20%", "20%", "20%"],
      dynamicRowsDetailAll: [],
      dynamicRowsDetailMore: [],
      serviceColumns: null,
      serviceRows: null,
    };
  },

  methods: {
    processFetchedData(rawData) {
      return rawData.map(({ _id, title, row, column, isEnabled }) => {
        return {
          rowId: _id,
          title: title,
          row: row,
          column: column,
          isEnabled: isEnabled,
          action: { edit: "show", delete: "show" },
        };
      });
    },
    createServices() {
      this.$router.push({ name: "AddHomepageServices" }).catch(() => {});
    },
    updateLayout() {
      var updatedDetails = {
        rows: this.serviceRows,
        columns: this.serviceColumns,
      };
      Axios.put(
        process.env.VUE_APP_HOST_SERVER +
          `/api/services_layout/update/5fbcacfad6cbba0a2a6abb6b`,
        updatedDetails
      ).then(() => {
        alert("Service layout is updated.");
        this.$router.go();
      });
    },
    viewPopup(id) {
      alert("viewing");
      alert(id);
    },
    editPopup(id) {
      // alert('editing')
      // alert(id)
      this.$router
        .push({
          name: "EditHomepageServices",
          params: { itemId: id },
        })
        .catch(() => {});
    },
    deletePopup(id) {
      // Update MongoDB
      Axios.delete(
        process.env.VUE_APP_HOST_SERVER + `/api/services/delete/${id}`
      ).then(() => {
        alert("Service is deleted.");
        this.$router.go();
      });
    },
  },
};
</script>

<style>
.dd-layout {
  border: 2px solid gray;
  border-radius: 10%;
  width: 30%;
  padding: 10;
}
.layout {
  display: inline-block;
}
</style>
